import React, { useEffect, useState } from "react";
import { Stack, Typography, useTheme } from "@mui/material";
import { Analytics as UserAnalytics } from "../../../api/User";
import dayjs from "dayjs";
import { useCookies } from "react-cookie";
import { CARD_STYLES } from "../../../constants/styles";
import { HeroFigure, StatementRow } from "../Analytics/analyticsUi";

interface Props {
    user_id: string;
}

const Analytics = (props: Props) => {
    const { user_id } = props;
    const theme = useTheme();
    const primary = theme.palette.primary.main;

    const [cookies] = useCookies(["uuid", "brand_id"]);
    const { uuid, brand_id } = cookies;

    const [analytics, setAnalytics] = useState<UserAnalytics | undefined>();

    useEffect(() => {
        if (!uuid || !brand_id) return;
        UserAnalytics.info(uuid, brand_id, user_id)
            .then((real) => setAnalytics(real))
            .catch(console.error);
    }, [uuid, brand_id, user_id]);

    if (!analytics) return null;

    // A visit = a Done booking (TASK-165's completion cron makes this real).
    return (
        <Stack sx={{ px: 2, pt: 0.5, pb: 3 }}>
            <Stack sx={CARD_STYLES} spacing={1.25}>
                {/* Money hero — what this client has earned the master */}
                <Stack spacing={0.25}>
                    <HeroFigure color={primary} size={40}>
                        €{Math.round(analytics.total ?? 0)}
                    </HeroFigure>
                    <Typography fontSize="13px" color="text.secondary">
                        Total earned
                    </Typography>
                </Stack>

                <Stack spacing={0} pt={0.5}>
                    <StatementRow
                        label="Average ticket"
                        value={`€${Math.round(analytics.average ?? 0)}`}
                    />
                    <StatementRow
                        label="Total appointments"
                        value={`${analytics.count ?? 0}`}
                    />
                    <StatementRow
                        label="Active appointments"
                        value={`${analytics.active ?? 0}`}
                    />
                    <StatementRow
                        label="Cancelled"
                        value={`${analytics.cancelled ?? 0}`}
                    />
                    <StatementRow
                        label="Client since"
                        value={
                            analytics.signup
                                ? dayjs(analytics.signup).format("DD.MM.YYYY")
                                : "—"
                        }
                    />
                </Stack>
            </Stack>
        </Stack>
    );
};

export default Analytics;
